import { Controller } from "@hotwired/stimulus"

// WA: show rate / inclusive radios only when "Charge sales tax" is checked.
export default class extends Controller {
  static targets = ["panel", "checkbox"]

  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  sync() {
    if (!this.hasPanelTarget || !this.hasCheckboxTarget) return
    const on = this.checkboxTarget.checked
    this.panelTarget.hidden = !on
    this.panelTarget.classList.toggle("u-hidden", !on)
  }
}
